import { useMutation, useQuery } from '@tanstack/react-query'

import {
  getMyInfo,
  getMyTicketList,
  getPaymentList,
  type MyInfoRequest,
  type MyPasswordRequest,
  patchMyInfo,
  patchMyPassword,
} from '~/features/mypage/apis/myInfo'
import { type Filters } from '~/features/mypage/types/my-page'

export const useMyTicketList = (filters: Filters) => {
  return useQuery({
    queryKey: ['myticket-list', filters],
    queryFn: () => getMyTicketList(filters),
  })
}

export const usePaymentList = (page: number) => {
  return useQuery({
    queryKey: ['payment-list', page],
    queryFn: () => getPaymentList(page),
  })
}

export const useMyInfo = () => {
  return useQuery({
    queryKey: ['my-info'],
    queryFn: () => getMyInfo(),
  })
}

export const usePatchMyInfo = () => {
  return useMutation({
    mutationFn: (data: MyInfoRequest) => {
      return patchMyInfo(data)
    },
  })
}

export const usePatchMyPassword = () => {
  return useMutation({
    mutationFn: (data: MyPasswordRequest) => {
      return patchMyPassword(data)
    },
  })
}
